import { Component, OnInit } from '@angular/core';
import { ExpenditureCategoryService } from '../expenditure-category.service';
import { ExpenditureCategory } from '../expenditure-category';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-expenditure-category-create',
  templateUrl: 'create.component.html',
})
export class ExpenditureCategoryCreateComponent implements OnInit {
  /**
   * Details of the expenditureCategory being created.
   */
  public expenditureCategory: ExpenditureCategory;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ExpenditureCategoryService} expenditureCategoryService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private expenditureCategoryService: ExpenditureCategoryService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.expenditureCategoryService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank expenditureCategory if required.
   */
  public ngOnInit(): void {
    if (!this.expenditureCategory) {
      this.expenditureCategory = new ExpenditureCategory();
    }
  }

  /**
   * Perform the create action which adds the new expenditureCategory into the backend.
   */
  public create() {
    const createExpenditureCategory = this.expenditureCategoryService
      .createExpenditureCategory(this.expenditureCategory)
      .subscribe(
        (result: ExpenditureCategory) => {
          this.notificationService.success(
            `ExpenditureCategory Created`,
            `New expenditureCategory ${
              result.name
            } has been created with ID of ${result.id}.`,
            5,
          );
          this.expenditureCategory = new ExpenditureCategory();
          createExpenditureCategory.unsubscribe();
          this.router.navigate(['/expenditure-categories']);
        },
        err => {
          this.notificationService.error(
            `Could not create ExpenditureCategory`,
            err.error.message,
            10,
          );
        },
      );
  }
}
